const onSpace =
  (handler) =>
  (e, ...args) => {
    if (e.key === ' ') {
      handler(e, ...args);
    }
  };

export default onSpace;
